import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';

//Test Comment

// Import containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent,
  AdminLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent,
  AdminLayoutComponent
]

// Import components
import {
  AppBugreportingComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  APP_SIDEBAR_NAV
} from './components';

const APP_COMPONENTS = [
  AppBugreportingComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  APP_SIDEBAR_NAV
]

// Import directives
import {
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
  DropZoneDirective
} from './directives';

const APP_DIRECTIVES = [
  // AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
  DropZoneDirective
]

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap';

// firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { environment } from '../environments/environment';

// app modules
import { CoreModule } from './core/core.module';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  imports: [
    CoreModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    // ChartsModule,
    BsDropdownModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    // TabsModule.forRoot(),
    ToasterModule,
    LayoutModule
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES
  ],
  providers: [
    ToasterService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/app.module.ts